import React, { memo } from 'react';
import { css, cx } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

type SeoTextProps = {
  seoTextHTML: string | null | undefined;
};

type SeoTextSectionProps = SeoTextProps & React.HTMLAttributes<HTMLElement>;

export const SeoText: React.FC<SeoTextSectionProps> = memo(({ seoTextHTML, className, ...props }) => (
  <section className={cx(sectionContainer, className)} {...props}>
    <section
      data-qa="seo-block"
      className={cx(sectionContent, sectionStyle)}
      dangerouslySetInnerHTML={{ __html: seoTextHTML ?? '' }}
    />
  </section>
));

export const sectionStyle = css`
  box-sizing: border-box;
  width: 1180px;
  margin-top: var(--space-1000);
  margin-right: auto;
  margin-left: auto;

  --collapsed-height: 320px;
  --max-content-height: 448px;
  --main-content-flex: 44 44 0;
  --side-content-flex: 15 15 0;

  ${breakpoints.only.desktop} {
    width: 940px;

    --collapsed-height: 320px;
    --max-content-height: 448px;
  }

  ${breakpoints.only.tablet} {
    width: 100%;
    padding-right: var(--space-675);
    padding-left: var(--space-675);

    --collapsed-height: 320px;
    --max-content-height: 448px;
    --main-content-flex: 44 44 0;
    --side-content-flex: 15 15 0;
  }

  ${breakpoints.to.tablet} {
    width: 100%;
    padding-right: var(--space-200);
    padding-left: var(--space-200);

    --collapsed-height: 360px;
    --max-content-height: 504px;
    --main-content-flex: 44 44 0;
    --side-content-flex: 15 15 0;
  }
`;

const sectionContainer = css`
  width: 100%;
  padding-top: var(--space-750);
  padding-bottom: var(--space-750);
  background-color: #f1f1f1;
`;

const sectionContent = css`
  padding: var(--space-375);
  margin-top: 0;
  background-color: var(--control-invert);

  h2 {
    margin: var(--space-75) 0 var(--space-100);
    font-size: var(--space-200);
    line-height: 21px;
    color: var(--text-secondary);
  }

  p {
    font-size: 12px;
    line-height: 20px;
    color: #666;
  }

  a {
    text-decoration: underline;
    color: var(--brand-primary);
  }

  img {
    max-width: 20em;
    height: auto;
  }
`;
